import { jWebReady } from '@jarvis/jweb-core'
export const closeServiceInstance = async (closeOptions = {}) => {
    const jweb = await jWebReady
  
    if (jweb && jweb.isNative) {
      const { ServiceRouting } = jweb.Plugins
      ServiceRouting.closeServiceInstance(closeOptions)
    }
  }